import HomepageHighlightClipScroller from './HomepageHighlightClipScroller';

export default HomepageHighlightClipScroller;
